import React, {useState} from "react";
import Styles from "../styles/ofbstyles.module.css";

const FormPayee = (props) => {
    const [options, setOptions] = useState(props.options);

    const search_and_select_option = () => {
        //If no letters typed at all, ignore this
        if(props.payee.trim().length === 0) {
            return;
        }

        //Get the options to check Through
        let options = document.getElementById('datalist_payees').options;

        //Try to find an option and select it
        for(let i = 0; i < options.length; i++) {
            if(options[i].value.toLowerCase().indexOf(props.payee.toLowerCase()) !== -1) {
                props.onChange(options[i].value);
                return;
            }
        }

        //If no option, then it must be a new payee, handle it
        props.payee_add_new_handler(props.payee);
    }
    return (
        <>
            <input
                type='text'
                name={props.name}
                id={props.name}
                className={Styles.ofb_text_input}
                value={props.payee}
                onChange={event => props.onChange(event.target.value)}
                list='datalist_payees'
                autoComplete='off'
                placeholder='Payee'
                onBlur={search_and_select_option}
            />
            <datalist id='datalist_payees'>
                {props.options.map((value, index) => (
                    <option key={index} value={value} />
                ))}
            </datalist>
        </>
    )
}
export default FormPayee;